import React, { useEffect } from 'react';
import { RBHBox, RBHText } from '../../../../shared/components';
import styleText from '../../../../shared/components/rbh-text/styles';
import styles from './styles';
import { Breadcrumb } from 'antd';
import { MODAL_TYPE } from '../../../../redux/general/general-constant';
import { generalCreators } from '../../../../redux/general/general-action';
import { GENERAL_STATE_KEY } from '../../../../redux/general/general-reducer';
import { useHistory } from 'react-router';
import { useDispatch } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { mainCreators } from '../../../main-action';
import { catCreators } from '../../FoodCategory/redux/cat-action';
import { MAIN_STATE_KEY } from '../../../main-reducer';
import { FormAddEdit } from '../components/FormAddEdit';
import commonStyle from '../../../../shared/theme/common-style';

export const AddMartProductScreen: React.FC<Props> = () => {
  const history = useHistory();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(mainCreators.setMainState(MAIN_STATE_KEY.HEADER_MENU, 5));
  }, []);

  const dispatchModal = (path: any) => {
    dispatch(generalCreators.setGeneralState(GENERAL_STATE_KEY.MODAL, {
      visible: true,
      onOk: () => history.push(path),
      type: MODAL_TYPE.CONFIRM_EDIT
    }));
  };

  const pushToMartProduct = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    history.push('/main/martproduct');
  };

  return (
    <>
      <RBHBox>
        <Breadcrumb style={styleText.breadCrumb}>
          <Breadcrumb.Item>
            <a data-testid={'breadcrumbHomepage'} id={'breadcrumbHomepage'} style={styleText.breadCrumbItemLink}
              onClick={() => dispatchModal('/main')}
            >
              <FormattedMessage id={'main.main'} />
            </a>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <a data-testid={'breadcrumbProductList'} id={'breadcrumbProductList'} style={styleText.breadCrumbItemLink}
              onClick={() => dispatchModal('/main/martproduct')}
            >
              <FormattedMessage id={'main.mart.product.landing.breadcrumb'} />
            </a>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <span data-testid={'breadcrumbAddProduct'} id={'breadcrumbAddProduct'} style={styleText.breadCrumbItem}>
              <FormattedMessage id={'main.mart.product.add.breadcrumb'} />
            </span>
          </Breadcrumb.Item>
        </Breadcrumb>
      </RBHBox>

      <RBHBox style={styles.header}>
        <RBHText data-testid={'headerAddProduct'} id={'headerAddProduct'} style={styleText.headerText} text={'main.mart.product.add.header'} />
      </RBHBox>
      <RBHText data-testid={'qcRemark'} id={'qcRemark'} style={styles.subTitleText} text={'main.mart.product.addEdit.qc.desc'} />

      <RBHBox style={commonStyle.formWrapper}>
        <FormAddEdit onSuccessCallback={pushToMartProduct} onCancel={dispatchModal} />
      </RBHBox>
    </>
  );
};

type Props = {};
